require('./../sass/_fake.scss'); // https://github.com/JeffreyWay/laravel-mix/issues/2064#issuecomment-532698484

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

require('./lodash');

import Vue from 'vue'
window.Vue = Vue;

// vue cookies
Vue.use(require('vue-cookies'));

require('./resource/index');
import router from './router'
import store from './store'

require('./bootstrap-vue');
require('./moment');
require('./translations');
require('./title');
require('./permissions');
require('./md5');

window.alertify = require('alertifyjs');
window.alertify.defaults.transition = "zoom";
window.alertify.defaults.theme.ok = "btn btn-primary";
window.alertify.defaults.theme.cancel = "btn btn-danger";
window.alertify.defaults.theme.input = "form-control";
window.alertify.defaults.glossary.title = window.APPDATA.name;
window.alertify.defaults.glossary.ok = _.get(window.APPDATA.translations, 'global.ok_label', 'OK');
window.alertify.defaults.glossary.cancel = _.get(window.APPDATA.translations, 'global.cancel_label', 'Cancel');
window.alertify.defaults.glossary.cancel = _.get(window.APPDATA.translations, 'global.cancel_label', 'Cancel');
window.alertify.defaults.notifier.position = 'top-right';

// Debug pass to Vue
Vue.config.devtools = window.APPDATA.debug;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

// Dynamic import
import App from './components/App'
// Vue.component('exam-types', () => import(/* webpackChunkName: "exam-types" */  './components/exam/Types.vue'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    // template  : '<App/>',
    components: { App },
    router,
    store,
});
